import { ANYTHING, CacheScenario, CacheTime, MethodType } from 'app/models/api/cache';
import { API_ENDPOINT } from './utils.service';

export const filtersServiceCache: () => CacheScenario[] = (): CacheScenario[] => [
  {
    description: 'method getIncidentTags, caching get of incidents tags',
    cacheTime: CacheTime.DEFAULT,
    endpoint: {
      url: `${API_ENDPOINT}/incidents/tags`,
      method: MethodType.GET,
    },
    cleaningEndpoints: [
      {
        url: `${API_ENDPOINT}/machines/${ANYTHING}/incidents`,
        method: MethodType.POST,
      },
      {
        url: `${API_ENDPOINT}/incidents/${ANYTHING}`,
        method: MethodType.PUT,
      },
      {
        url: `${API_ENDPOINT}/incidents/tags`,
        method: MethodType.POST,
      },
    ],
  },
  {
    description: 'method getScheduleLabels, caching get of schedules labels',
    cacheTime: CacheTime.DEFAULT,
    endpoint: {
      url: `${API_ENDPOINT}/filters/taskschedulelabels`,
      method: MethodType.GET,
    },
    cleaningEndpoints: [
      // create regular and flexible schedules for new created tasks
      {
        url: `${API_ENDPOINT}/machines/${ANYTHING}/tasks/${ANYTHING}/schedules`,
        method: MethodType.POST,
      },
      // update regular schedules for already created tasks
      {
        url: `${API_ENDPOINT}/machines/${ANYTHING}/tasks/${ANYTHING}/schedules/update`,
        method: MethodType.POST,
      },
      // create flexible schedules
      {
        url: `${API_ENDPOINT}/machines/${ANYTHING}/tasks/schedules/flexible`,
        method: MethodType.POST,
      },
      // update flexible schedules
      {
        url: `${API_ENDPOINT}/machines/${ANYTHING}/tasks/schedules/flexible/update`,
        method: MethodType.POST,
      },
      // delete hole maintenance task
      {
        url: `${API_ENDPOINT}/machines/${ANYTHING}/tasks/delete`,
        method: MethodType.POST,
      },
    ],
  },
];
